import type { EnvironmentApi, EnvironmentId } from "@cmmd-forge/contracts";

import { readEnvironmentApi } from "../environmentApi";
import { ensureRelayRuntimeEnvironmentConnection } from "../environments/runtime/service";
import { classifyEnvironmentId } from "../environments/environmentIdClassification";

export async function ensureDesktopRuntimeEnvironmentApi(input: {
  readonly environmentId: EnvironmentId;
  readonly primaryEnvironmentId: EnvironmentId | null;
  readonly label: string;
  readonly readApi?: (environmentId: EnvironmentId) => EnvironmentApi | undefined;
  readonly ensureRelayConnection?: typeof ensureRelayRuntimeEnvironmentConnection;
}): Promise<EnvironmentApi | undefined> {
  const readApi = input.readApi ?? readEnvironmentApi;
  const existing = readApi(input.environmentId);
  if (existing) return existing;
  if (
    input.environmentId === input.primaryEnvironmentId ||
    classifyEnvironmentId(input.environmentId).isCloud
  ) {
    // Every cloud shape, legacy `cmmd-runtime:` id and durable `env_` id alike,
    // is addressed through its own connection path elsewhere. Neither one is a
    // desktop machine this relay dance could attach to, so both no-op here.
    return undefined;
  }
  await (input.ensureRelayConnection ?? ensureRelayRuntimeEnvironmentConnection)({
    runtimeId: input.environmentId,
    label: input.label,
  });
  const attached = readApi(input.environmentId);
  if (!attached) {
    throw new Error("The selected desktop runtime connected without exposing its Forge API.");
  }
  return attached;
}
